import { useState } from 'react';
import PropTypes from 'prop-types';
import { FaTimes } from 'react-icons/fa';

import { addHashToHexColor, getsessionStorageData } from '../../lib';
import { sessionStorageKeys } from '../../constants';
import './PredifinedPopUpType2.css';

const PredifinedPopUp = ({
    props: {
        popupTopImage: imageUrl,
        popupTitle: title,
        popupText: desc,
        popupButton1Text: btnText,
        popupButton1Link: btnUrl,
        popupID,
        popupWidth,
        popupHeight,
        popupBorderRadius,
        popupBorderColor,
        popupBackgroundColor,
        popupVerticalAlign = 'top',
        popupHorrizontalAlign = 'left',

        popupCloseButtonColor,
        popupCloseButtonBackgroundColor,

        popupButton1Background,
        popupButton1FontColor,
        popupButton1BorderColor,
        popupButton1FontSize,

        popupOpenInterval,
        textboxPlaceHolder,
        textboxPlaceHolder2,
        termsAndConditionsUrl,
        popupButton1MessageAfterPress,
        imageTopMargin: topMargin,
        popupBottomMargin: bottomMargin,
        popupLeftMargin: leftMargin,
        popupRightMargin: rightMargin,
    },
    extraClass = '',
}) => {
    const closedOfferPopups = getsessionStorageData(
        sessionStorageKeys.CLOSED_OFFER_POPUPS,
        []
    );

    let initialState;

    if (popupOpenInterval === 'Everytime') {
        initialState = true;
    } else {
        initialState = closedOfferPopups.indexOf(popupID) === -1;
    }

    const [isOpen, setIsOpen] = useState(initialState);

    const closePopup = () => {
        if (
            closedOfferPopups.indexOf(popupID) === -1 &&
            popupOpenInterval !== 'Everytime'
        ) {
            closedOfferPopups.push(popupID);
            sessionStorage.setItem(
                sessionStorageKeys.CLOSED_OFFER_POPUPS,
                JSON.stringify(closedOfferPopups)
            );
        }
        setIsOpen(false);
    };

    let positionClass = '';

    if (popupVerticalAlign && popupHorrizontalAlign) {
        positionClass = `ab-offer-popup-cnt--${popupVerticalAlign
            .toLocaleLowerCase()
            .replace('middle', 'center')}-${popupHorrizontalAlign
            .toLocaleLowerCase()
            .replace('middle', 'center')}`;
    }

    const popupCntStyles = {
        backgroundColor: addHashToHexColor(popupBackgroundColor),
        borderColor: addHashToHexColor(popupBorderColor),
        height: popupHeight,
        width: popupWidth,
        marginTop: topMargin,
        marginBottom: bottomMargin,
        marginLeft: leftMargin,
        marginRight: rightMargin,
    };

    const popupInnerCntStyles = {
        borderRadius: popupBorderRadius,
    };

    // const popupCloseBtnStyles = {
    //     backgroundColor: addHashToHexColor(popupCloseButtonBackgroundColor),
    //     color: addHashToHexColor(popupCloseButtonColor),
    // };

    // const popupLinkStyles = {
    //     backgroundColor: addHashToHexColor(popupButton1Background),
    //     borderColor: addHashToHexColor(popupButton1BorderColor),
    //     color: addHashToHexColor(popupButton1FontColor),
    //     fontSize: addHashToHexColor(popupButton1FontSize),
    // };

    // const handleSubmit = async (event) => {
    //     event.preventDefault();
    // };

    return (
        isOpen && (
            <div
                className={`ab-offer-popup-cnt ${positionClass} ${extraClass}`}
                style={popupCntStyles}
            >
                <button
                    className="ab-offer-popup-close-btn"
                    // style={popupCloseBtnStyles}
                    onClick={closePopup}
                >
                    <FaTimes />
                </button>

                <div
                    className="ab-offer-predifined-inner-cnt-type-two"
                    style={popupInnerCntStyles}
                >
                    {imageUrl && (
                        <a
                            href={`${btnUrl}`}
                            className="ab-offer-popup-header"
                            style={{ display: 'flex' }}
                        >
                            <div className="ab-offer-predifined-image">
                                <img
                                    src={imageUrl}
                                    alt=""
                                    style={{ height: '100%' }}
                                />
                            </div>
                        </a>
                    )}
                    {/* <form
                        className="ab-offer-predifined-form"
                        onSubmit={handleSubmit}
                    >
                        <div
                            className="ab-offer-predifined-body"
                            style={popupInnerCntStyles}
                        >
                            <h4
                                className="ab-offer-popup-title"
                                dangerouslySetInnerHTML={{ __html: title }}
                            ></h4>
                            <div
                                className="ab-offer-predifined-desc"
                                dangerouslySetInnerHTML={{ __html: desc }}
                            ></div>
                            <button
                                type="submit"
                                className="ab-offer-predifined-link"
                                style={popupLinkStyles}
                                id="ab-offer-predifined-submit"
                            >
                                {btnText}
                            </button>
                        </div>
                    </form> */}
                </div>
            </div>
        )
    );
};

// TODO: MAKE THIS BETTER
PredifinedPopUp.propTypes = {
    props: PropTypes.object,
    imageUrl: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    btnText: PropTypes.string,
    btnUrl: PropTypes.string,
    extraClass: PropTypes.string,
};

export default PredifinedPopUp;
